import { Typography, Divider, Tooltip, Grid } from "@mui/material";
import { useContext, useEffect } from "react";
//@ts-ignore
import Tree from "react-d3-tree";
import { MainContext } from "../context/MainContextProvider";
import React from "react";
import { TbBrandTorchain } from "react-icons/tb";
import { FaSolarPanel } from "react-icons/fa";
import { BsPlug } from "react-icons/bs";
import { LiaSolarPanelSolid } from "react-icons/lia";
import { BiExpandAlt } from "react-icons/bi";

export type RopTreeChartProps = {
  title?: string;
  data: RopTreeChartData;
  headerItems?: {
    name: string;
    value: string | number | undefined;
  }[];
};
export type RopTreeChartData = {
  name: string;
  attributes?: {
    name: string;
    value: string | number | undefined;
  }[];
  children?: RopTreeChartData[];
};
export type D3TreeChartData = {
  name: string;
  attributes?: any;
  children?: D3TreeChartData[];
  __rd3t?: any;
};
function NodeIcon(props: { name: string; onClick: () => void }) {
  const { name, onClick } = props;
  const iconProps = {
    style: { width: "20px", height: "20px" },
    x: -8,
    y: -8,
    onClick: onClick,
  };

  if (name.includes("Planta")) {
    return <TbBrandTorchain {...iconProps} />;
  }
  if (name.includes("UG")) {
    return <FaSolarPanel {...iconProps} />;
  }
  if (name.includes("Inversor")) {
    return <BsPlug {...iconProps} />;
  }
  if (name.includes("String")) {
    return <LiaSolarPanelSolid {...iconProps} />;
  }
}
export default function RopTreeChart(props: RopTreeChartProps) {
  const [nodeCardDimensions, setNodeCardDimensions] = React.useState({
    width: 0,
    height: 0,
  });
  const { theme } = useContext(MainContext);
  const { title, data, headerItems } = props;
  const chartData: D3TreeChartData = parseRopTreeChartData(data);
  const treeDivRef = React.useRef(null);
  const treeRef = React.useRef(null);

  const treeDivContainer = treeDivRef.current as HTMLElement | null;

  const nodeCardRef = React.useRef(null);
  const nodeCardContainer = nodeCardRef.current as HTMLElement | null;
  // const toggleAllNodes = (type: "expand" | "collapse") => {
  //   if (treeRef.current) {
  //     const current = treeRef.current as any;
  //     const rootNode = current.state.data;
  //     const collapsed = type === "collapse";
  //     expandNodesRecursively(rootNode[0], collapsed);
  //     current.setState({ data: rootNode });
  //   }
  // };

  const expandNodesRecursively = (node: any, collapsed: boolean) => {
    if (node) {
      if (!node.name.includes("Planta")) node.__rd3t.collapsed = collapsed;
      if (node.children && node.children.length > 0) {
        node.children.forEach((child: any) => {
          expandNodesRecursively(child, collapsed);
        });
      }
    }
  };
  function getContainerDimensions() {
    if (treeDivContainer) {
      const { width, height } = treeDivContainer.getBoundingClientRect();
      return { width, height };
    }
    return { width: 0, height: 0 };
  }
  const dimensions = getContainerDimensions();

  useEffect(() => {
    if (nodeCardContainer) {
      const { width, height } = nodeCardContainer.getBoundingClientRect();
      setNodeCardDimensions({ width, height });
    }
  }, [nodeCardContainer]);

  return (
    <>
      <div className="text-start mb-2 w-100">
        <div
          style={{ minHeight: "32px" }}
          className="d-flex justify-content-between w-100 align-items-center"
        >
          <Typography marginBottom={1} color={theme.primaryTextColor}>
            {title}
          </Typography>
          <div className="d-flex flex-row justify-content-around">
            {headerItems?.map((item, index) => (
              <Typography
                sx={{
                  fontSize: "0.8rem",
                  fontWeight: "bold",
                  marginRight: "8px",
                }}
                key={index}
                color={theme.primaryTextColor}
              >
                {item.name}: {item.value}
              </Typography>
            ))}
          </div>
          {/* <div className="d-flex flex-row justify-content-around">
            <div>
              <Button
                onClick={() => {
                  toggleAllNodes("expand");
                }}
                variant="contained"
                color="primary"
                style={{ marginRight: "5px" }}
              >
                Expandir
                <BiExpand
                  style={{
                    width: "20px",
                    height: "20px",
                    marginLeft: "5px",
                  }}
                />
              </Button>
            </div>
            <div>
              <Button
                onClick={() => {
                  toggleAllNodes("collapse");
                }}
                variant="contained"
                color="primary"
              >
                Retrair
                <BiCollapse
                  style={{
                    width: "20px",
                    height: "20px",
                    marginLeft: "5px",
                  }}
                />
              </Button>
            </div>
          </div> */}
        </div>
        <Divider
          variant="fullWidth"
          style={{ backgroundColor: theme.muiTheme.palette.secondary.main }}
        />
      </div>

      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
        }}
        ref={treeDivRef}
      >
        <Tree
          ref={treeRef}
          hasInteractiveNodes
          renderCustomNodeElement={(rd3tProps: any) => {
            const nodeData: D3TreeChartData = rd3tProps.nodeDatum;
            const isCollapsedWithChildren = Boolean(
              nodeData.children && !nodeData.__rd3t.collapsed
            );

            return (
              <React.Fragment>
                <ellipse
                  onClick={async () => {
                    rd3tProps.toggleNode();
                  }}
                  rx={15}
                  ry={15}
                  fill={
                    nodeData.children
                      ? "rgba(253, 184, 19, 1)"
                      : "rgba(253, 220, 140, 1)"
                  }
                  style={{
                    backgroundColor: "rgba(253, 184, 19, 1)",
                  }}
                />
                <NodeIcon
                  name={rd3tProps.nodeDatum.name}
                  onClick={rd3tProps.toggleNode}
                />
                {/* <IoAlertCircle
                  style={{
                    width: "20px",
                    height: "20px",
                    fill: "red",
                    color: "red",
                    backGroundColor: "red",
                  }}
                  x={isCollapsedWithChildren ? 25 : 95}
                  y={isCollapsedWithChildren ? 8 : -10}
                /> */}
                {/* TODO: Adicionar validação de existência de alarmes para nó, e exibir componente acima a partir da validação */}
                <foreignObject
                  height={nodeCardDimensions.height}
                  width={nodeCardDimensions.width}
                  x={isCollapsedWithChildren ? -35 : 20}
                  y={isCollapsedWithChildren ? 25 : -10}
                >
                  <Tooltip title="Clique para ver detalhes">
                    <div
                      ref={nodeCardRef}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        padding: "2px",
                        backgroundColor: "rgba(253, 184, 19, 1)",
                        borderRadius: "5px",
                        width: "70px",
                        height: "fit-content",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",

                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: 8,
                          }}
                        >
                          {nodeData.name}
                        </Typography>
                        <BiExpandAlt
                          style={{ width: "8px", height: "8px" }}
                          x={isCollapsedWithChildren ? 25 : 95}
                          y={isCollapsedWithChildren ? 8 : -10}
                        />
                      </div>
                      {nodeData.attributes &&
                        Object.keys(nodeData.attributes).map(
                          (labelKey: string, i) => {
                            const nodeLabel = nodeData.attributes
                              ? nodeData.attributes[labelKey]
                              : "";
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                                key={i}
                              >
                                <Typography
                                  style={{
                                    fontSize: 8,
                                  }}
                                >
                                  {labelKey}:
                                </Typography>
                                <Typography
                                  key={i}
                                  style={{
                                    fontSize: 8,
                                  }}
                                >
                                  {nodeLabel}
                                </Typography>
                              </div>
                            );
                          }
                        )}
                    </div>
                  </Tooltip>
                </foreignObject>
              </React.Fragment>
            );
          }}
          // zoom: 1,
          // scaleExtent: { min: 0.1, max: 1 },
          nodeSize={{ x: 200, y: 300 }}
          separation={{ siblings: 0.25, nonSiblings: 0.25 }}
          scaleExtent={{ min: 0.1, max: 10 }}
          zoom={1}
          data={chartData}
          dimensions={dimensions}
          orientation={"horizontal"}
          centeringTransitionDuration={800}
          translate={{ x: dimensions.width / 2, y: dimensions.height / 2 }}
          // translate={{ x: 100, y: dimensions.height / 2 }}
          // pathFunc={this.state.pathFunc}
          collapsible={true}
          // initialDepth={1}
          zoomable={true}
          draggable={true}
          enableLegacyTransitions={true}
          // transitionDuration={this.state.transitionDuration}
          // depthFactor={40}
          // styles={this.state.styles}
          // shouldCollapseNeighborNodes={true}
          // // onUpdate={(...args) => {console.log(args)}}
          // onNodeClick={(node) => {
          //   console.log("onNodeClick");
          // }}
          // onNodeMouseOver={(...args) => {
          //   console.log('onNodeMouseOver', args);
          // }}
          // onNodeMouseOut={(...args) => {
          //   console.log('onNodeMouseOut', args);
          // }}
          // onLinkClick={(...args) => {
          //   console.log('onLinkClick');
          //   console.log(args);
          // }}
          // onLinkMouseOver={(...args) => {
          //   console.log('onLinkMouseOver', args);
          // }}
          // onLinkMouseOut={(...args) => {
          //   console.log('onLinkMouseOut', args);
          // }}
        />
      </Grid>
    </>
  );
}

function parseRopTreeChartData(data: RopTreeChartData): any {
  return {
    name: data.name,
    attributes: ropAttributesToD3Attributes(data.attributes),
    children: data.children?.map((child) => parseRopTreeChartData(child)),
  };
}

function ropAttributesToD3Attributes(
  attributes?: {
    name: string;
    value: string | number | undefined;
  }[]
): object {
  if (!attributes) {
    return {};
  }
  const array = attributes.map((attribute) => ({
    [attribute.name]: attribute.value,
  }));
  const obj = arrayToObject(array);
  return obj;
}
function arrayToObject(array: any[]) {
  var obj: any = {};
  array.map((item) => {
    Object.entries(item).map(([key, value]) => {
      obj[key] = value;
    });
  });
  return obj;
}
